import Escola from '@pages/Escola/Escola';

export default Escola;
